import $ from 'jquery'

var deacExplainOverlay = function($element) {

  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $learnMoreLink,
      $explainOverlay;

  // constructor
  function init() {
    $explainOverlay = $('.deac-explain-overlay', $mainContainer);
    $learnMoreLink = $('.ace-marketing__deac-learn-more', $mainContainer);

    bindDomEvents();
  }

  /* PRIVATE METHODS */

  function bindDomEvents() {

    $learnMoreLink.on('click', function(e) {
      e.preventDefault();
      showExplainOverlay($explainOverlay, $(this));
    });

    $('a:first', $explainOverlay).on('keydown', function(e) {
      if (e.keyCode == $.ui.keyCode.TAB && e.shiftKey) {
        e.preventDefault();
        SOPHIA.closeOverlayBox();
      }
    });
  }

  function showExplainOverlay(html, focus) {
    SOPHIA.overlayBox(html, {
      afterLoad: function() {
        $('.deac-explain-invisible-link').trigger('focus');
        $('.deac-explain-invisible-link').on('keydown', function(e){
          if (e.keyCode == $.ui.keyCode.TAB && e.shiftKey) {
            e.preventDefault();
            SOPHIA.closeOverlayBox();
          }
        });
      }
    }, focus);
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
    // public methods go here
  };
}

// jQuery plugin method
$.fn.deacExplainOverlay = function() {
  return this.each(function() {
    var $this = $(this);

    // If not already stored, store plugin object in this element's data
    if (!$this.data('deacExplainOverlay')) {
      $this.data('deacExplainOverlay', deacExplainOverlay($this));
    }
  });
};
